
import { Component, ElementRef, Input, SimpleChanges, ViewChild, inject, OnInit, OnChanges, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../services/loader/loader.service';
import { UserPreferencesService } from '../../services/user-preferences/user-preferences.service';
import { GlobalService } from '../../services/global/global-service';
import { ToastService } from '../../services/toast/toast.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { CommonConfirmationDialog } from '../../models/user-preferences.model';
import { SystemFormService } from '../../services/system-form/system-form-service';
import { BOGSetting, BOGSettingsSystemForm, SystemFormSettingType } from '../../models/bog-settings.model';
import { Subscription } from 'rxjs';
import { TemplateService } from '../../services/template/template-service';


@Component({
  selector: 'app-system-form',
  standalone: false,
  templateUrl: './system-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './system-form.component.scss'
})
export class SystemFormComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private loaderService = inject(LoaderService);
  private userPreferencesService = inject(UserPreferencesService);
  private systemFormService = inject(SystemFormService);
  private globalService = inject(GlobalService);
  private toastService = inject(ToastService);
  private templateService = inject(TemplateService);
  private dialog = inject(MatDialog);

  @ViewChild('filterTextBox') inputData: any;
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
   @Input() disabled = false;
    @Input() systemFormId: number;
  subs = new Subscription();
  public filters = [];
  userPreferencesData: any;
  systemFormData: any[] = [];
  moduleName: string;
templateName: string;

  async ngOnInit(): Promise<void> {
    const segments = this.router.url.split('/');
    this.moduleName = segments[segments.length - 1] || '';
    if (this.moduleName == SystemFormSettingType.BOGSettings.toLowerCase()) {
      this.templateName = "BOG Form";
    }
    this.loadPreferenceData();
    this.getSystemFormList();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['systemFormId'] && this.systemFormId) {
      console.log('systemFormId changed to:', this.systemFormId);
      this.getSystemFormList();
    }
  }
  ngAfterViewInit() {

  }

  loadPreferenceData() {
    this.userPreferencesData = this.userPreferencesService.getUserPreferencesData();
  }

  onDeleteSystemForm(systemFormObj: BOGSettingsSystemForm) {
    const dialogData: CommonConfirmationDialog = {
      buttons: [
        { name: 'Cancel', class: '!text-base', color: 'accent' },
        { name: 'Delete', class: '!text-base', handler: () => { this.checkAndDeleteSystemform(systemFormObj.id,systemFormObj.templateId); } },
      ],
    };

    const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '500px', width: '90%', panelClass: 'cmn-dialog', data: dialogData,
    });

    confirmDialogRef.afterClosed().subscribe({
      next: () => { },
      error: (err) => { console.log('err: ', err); },
    });
  }

 
onSystemFormClick(item: any) {
  if (!item || !item.templateId || item.templateId === 0) {
    // go to new form
    this.router.navigate(
      ['/templates/new'],
      { queryParams: { systemFormId: this.systemFormId, moduleName: this.moduleName } }
    );
  } else {
    // go to edit form
    this.router.navigate(
      ['/templates/edit'],
      { queryParams: { id: item.templateId,  moduleName: this.moduleName } }
    );
  }
}

checkAndDeleteSystemform(id:number, templateId: number){
   const payload = {
      tableName: 'tblTemplate',
      fieldName: 'templateId',
      fieldValue: templateId.toString(),
      ignoreTableList: `'tblBogSettingsSystemForm'`,
    };
    this.loaderService.showLoader();
    this.globalService.checkDataIntegrityIgnoredWith(payload.tableName,
          payload.fieldName,
          payload.fieldValue,
          payload.ignoreTableList).subscribe({
        next: (response) => {
          if(parseInt(response) == 0){
            this.deleteTemplate(templateId);
            this.deleteSystemForm(id);
          }
          else {
            this.loaderService.hideLoader();
            this.toastService.showWarning(`Data is already in use`);
          }
        },
        error: (err: any) => {
          console.log(err);
          this.loaderService.hideLoader();
          this.toastService.showError('Error while deleting Template.');
        }
    });
  }
    deleteTemplate(templateId: number){
    this.templateService.delete(templateId).subscribe({
      next: () => {
        this.loaderService.hideLoader();
        this.toastService.showSuccess(`Template deleted successfully`);
        this.getSystemFormList();
      },
      error: (err: any) => {
        console.log(err);
        this.loaderService.hideLoader();
        this.toastService.showError('Error while deleting Template.');
      },
    });
  }
  deleteSystemForm(id:number) {
    
    this.loaderService.showLoader('Deleting system form...');
    switch (this.moduleName.toLowerCase()) {
      case SystemFormSettingType.BOGSettings:
          this.systemFormService.deleteBOGSettingSystemForm(id).subscribe({
          next: () => {
            this.loaderService.hideLoader();    
            this.toastService.showSuccess('System form deleted successfully.');
          },
          error: (err) => {
            this.loaderService.hideLoader();
            this.toastService.showError('Error while deleting system form.');
            console.error('Error while deleting system form:', err);
          },
        });  
        break;
      default:
        this.loaderService.hideLoader();
        this.toastService.showError('Invalid module name.');
        return;
    }
    
  }

  setDataToCookie(cookieName: string, data: any): void {
    sessionStorage.setItem(cookieName, JSON.stringify(data));
  }
  formatGroupValue(value: string): string {
    return moment(value).format('DD MMM YYYY');
  }

  // Select all toggle
  toggleSelectAll(event: any) {
    const checked = event.checked;
    this.systemFormData.forEach(item => item.selected = checked);
  }
getSystemFormList() {
    this.loaderService.showLoader('Loading system forms...');
    switch (this.moduleName.toLowerCase()) {
      case SystemFormSettingType.BOGSettings:
        const payload = { bogFormId: this.systemFormId};
        this.systemFormService.getBOGSettingSystemFormList(payload).subscribe({
          next: (data: any) => {
            this.systemFormData = data;
            this.loaderService.hideLoader();
          },
          error: (err) => {
            this.loaderService.hideLoader();    
            this.toastService.showError('Error while fetching system forms.');
            console.error('Error while fetching system forms:', err);
          },
        });  
        break;      
      default:
        this.loaderService.hideLoader();
        this.toastService.showError('Invalid module name.');
        return;
    }   
  }


  // Get selected items
  getSelectedSystemForm() {
    return this.systemFormData.filter(item => item.selected);
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}